module.exports = __webpack_public_path__ + "static/img/his-icon.0b12df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/his-icon.png
// module id = Pv8N
// module chunks = 1